// 页面可能在公共头加载完成前请求登录（例如订阅页）。保留这次请求，挂载后打开。
let pendingLogin = false

export function openPcLogin() {
  if (window.hopegooLogin) {
    window.hopegooLogin()
  }
  else {
    pendingLogin = true
  }
}

export function flushPcLogin() {
  if (pendingLogin) {
    pendingLogin = false
    openPcLogin()
  }
}

export function cancelPendingPcLogin() {
  pendingLogin = false
}
